import React, { Component } from 'react';
import styled from 'styled-components';
// import Button from '@vzrf/react-button';
import { Button } from '@vds/buttons';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vzrf/react-theme-helpers';
// import { packageDetails } from '../assets/data/allChannels';
import { fetchRegionId, getChannelPackageViewFiosFive } from '../../../action/buildProduct';
import { updateSCcustomEvent, tempSCData, updateSCTags } from '../../../service/dtmTag';
import { InHomeUtils } from '../../../util/inhomeUtils';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Title } from '@vds/typography';
//getDTMInit

const ModalContaier = styled.div`
    // padding: ${calculateRem(0, 0, 20, 0)};
    margin: ${calculateRem(50, 0, 0)};
  @media only screen and (min-width: ${breakpoints.md}) {
    // padding: ${calculateRem(0, 0, 30, 0)};
    margin: ${calculateRem(0, 0, 0)};
  };
  
  @media only screen and (max-width: 767px) {

    margin-top:1em
  };

`;

const ScreenHeaderContainer = styled.div`
  
margin: ${calculateRem(0, 10, 22)};

  @media only screen and (min-width: ${breakpoints.md}) {
    background: #f3f3f3;
    margin: ${calculateRem(0, 0, 20)};
    padding: ${calculateRem(38, 40)};
  };
`;
/*
const ScreenHeader = styled.h2`
  font-size: ${calculateRem(24)};
`;*/

const SelectedChannelsContainer = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;

    @media only screen and (min-width: ${breakpoints.md}) {
        justify-content: start;
    }
`;

const SelectedTitles = styled.div`
    flex:0 0 50px;
    text-align: center;

    @media only screen and (min-width: ${breakpoints.md}) {
        flex:0 0 63px;
        margin-right: 10px;
    }

    & img {
        width: 50px;

    }
`;

const ButtonRow = styled.div`
    width: 100%;
    text-align: left;

    // & ${Button} {
    //     margin: 0;
    //     border-radius: 0;
    //     width: ${calculateRem(240)};
    //     border: 0;
    //     padding-top: ${calculateRem(12)};
    //     padding-bottom: ${calculateRem(12)};
    //     background: #333333;
    //     line-height: 1.25;
    //   }
`;

const UnorderedList = styled.ul`
    line-height: 1.25;
    letter-spacing: 0.25px;
    color: #333333;
    list-style: none;
    padding: 0;
`;

const AllChannelsContainer = styled.div`
    margin: ${calculateRem(0, 20, 15)};
    max-height: ${calculateRem(398)};
    overflow: auto;

    @media only screen and (min-width: ${breakpoints.md}) {
        // margin: ${calculateRem(0, 40, 17)};
        max-height: 220px;
    }

    @media only screen and (max-width: 767px) {
        max-height: calc(100vh - 350px);
    }

    @media only screen and (max-width: 350px) {
        max-height: calc(50vh);
    }
`;

const AllChannelsInfo = styled.p`
    margin: ${calculateRem(0, 0, 20)};
    font-size: ${calculateRem(14)};
    line-height: 1.29;
    color: #767676;
`;

const ChannelGroupTitle = styled.h3`
    font-family: "BrandFont-Text", Arial, sans-serif;;
    font-weight: bold;
    font-size: ${calculateRem(16)};
    margin: ${calculateRem(0, 0, 7)};
    color: #333333;
    letter-spacing: 0.25px;
    line-height: normal;
`;

const UnorderedListItem = styled.li`
    letter-spacing: 0.25px;
    color: #333333;
`;
 
const Span = styled.span`
   float:right;
   margin-right:10px;
`;

class FiosFiveChannelReviewComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fiosFiveModalSate: 'reviewChannels',
            selectedChannels: this.setSelectedChannels(props.selectedChannels),
            allChannels:{}           
        };
        this.isReskin = props.buildProduct?.isReskin && props.lqState && props.lqState.runtimeKey && props.lqState.runtimeKey.EnableReskin === 'Y';
    }

    componentDidMount(){
        //focus close button by default - accessibility
        let closeBtnEl = document.getElementsByClassName('styles_closeButton__20ID4');
        closeBtnEl && closeBtnEl.length && closeBtnEl[0].focus();

        const { vhoParams, dispatch, visitId, visitorId, product } = this.props;
        let channels=[product.id];
        let allPackageIds = {
            "PACKA": undefined,
            "PACKB": undefined
        }; 
        for (var i = 0; i < 5; i++) {
            let currChannel = this.props.selectedChannels[i];
            channels.push(currChannel.id);
            if (currChannel.packageType && !allPackageIds[currChannel.packageType]) {
                allPackageIds[currChannel.packageType] = currChannel.packageId;
            }            
        }
        let packageId = channels.join();
        //add in package info
        if (allPackageIds.PACKA || allPackageIds.PACKB) {
            packageId = packageId + "," + (allPackageIds.PACKA || allPackageIds.PACKB);
        }        
        
        getChannelPackageViewFiosFive(visitId, visitorId, vhoParams.lfa, vhoParams.vhoName, packageId, dispatch);        
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.packageDetails !== prevProps.packageDetails) {
    //         console.log('this.props.packageDetails,', this.props.packageDetails);
    //         this.props.packageDetails.channesnameview && this.setState({allChannels: sortAllChannels(this.props.packageDetails)}); 
    //     }
    //   }

    setSelectedChannels = (selectedChannels) => {
        let channelsToDisplay = [];
        for (var i = 0; i < 5; i++) {
            const isDisplayHasChannel = selectedChannels.length >= i+1;
            channelsToDisplay.push({
                id: isDisplayHasChannel ? selectedChannels[i].id : 'empty-' + i+1,
                name: isDisplayHasChannel ? selectedChannels[i].name : '',
                logo: isDisplayHasChannel ? this.props.channelImgPath + selectedChannels[i].logo  : '',
                ishasChannel: isDisplayHasChannel   
            });
        }
        return channelsToDisplay;
    }

    back = () => {
        this.props.back(['pickChannels', this.props.selectedChannels]);
        updateSCTags("back");
    }

    componentWillMount() {       
        tempSCData.detailPageName = "byob| tv| your fios tv| channel review";
        tempSCData.events = "event5";
        updateSCcustomEvent("accordionOpen","ddAddToCartEvent","detailPageName,events");
    }

    render() {
        const title = 'Channel review';
        return (
            <React.Fragment>
                <ModalContaier className="ResknModalHeader">
                    {/* <ScreenHeaderContainer> */}
                    <ModalTitle>
                        {title}
                    </ModalTitle>                  
                    {/* </ScreenHeaderContainer> */}
                <ModalBody>
                    {this.isReskin &&
                        <AllChannelsInfo className="margin-bottom-large">
                            Here's a full list of available channels.
                        </AllChannelsInfo>
                    }
                    <SelectedChannelsContainer className="margin-bottom-medium">
                        {
                            this.state.selectedChannels.map((channel, index) =>
                                <SelectedTitles key={channel.id}>
                                    <img alt={channel.name} src={channel.logo} className="channelReviewSelected"/>
                                </SelectedTitles>)
                        }
                    </SelectedChannelsContainer>

                    <AllChannelsContainer tabIndex="0">   
                        {this.props.packageDetails && Object.keys(this.props.packageDetails).length > 0 && Object.keys(this.props.packageDetails).map((keyName, i) => (
                            <React.Fragment key={keyName}>
                                <ChannelGroupTitle>{keyName}</ChannelGroupTitle>
                                <UnorderedList>
                                    {
                                        this.props.packageDetails[keyName].map((channel, index) => (
                                            <UnorderedListItem key={channel.channelno}>{channel.channelname} <Span>{channel.channelno}</Span></UnorderedListItem>
                                        ))
                                    }
                                </UnorderedList>
                            </React.Fragment>
                        ))}
                        </AllChannelsContainer>
                </ModalBody>
                    <ButtonRow className="modalFooterButtonReskin2">
                        <Button onClick={this.back}>Back</Button>
                    </ButtonRow>      
                </ModalContaier>
                
            </React.Fragment>
        );
    }
}

export default FiosFiveChannelReviewComponent;


 